import React from 'react';
import CommonGrid from '../../CommonCompo/CommonGrid/CommonGrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from 'primereact/dialog';
import { renderField } from '../../../utils/Helper';
import CommanDialog from '../../CommonCompo/CommanDialog/CommanDialog';
import { useCreateScreens } from '../../../Hooks/Features/TaskLayout/Screens/useCreateScreens';
import ScreenConfiguration from './ScreenConfiguration';
import _ from 'underscore';

const CreateScreens = ({ filterValues, setFilterValues }) => {
    const { columns, rowData, visible, setVisible, fieldValues, handleChange, formJson, upsertScreen, loader, setFieldValues } = useCreateScreens({ filterValues, setFilterValues })

    return (
        <div className="">
            {
                !_.isEmpty(filterValues?.config) ? <ScreenConfiguration filterValues={filterValues} setFilterValues={setFilterValues} visible={visible} setVisible={setVisible} upsertScreen={upsertScreen} />
                    : <>
                        <div className="d-flex align-items-center gap-2 mb-2 w-100">
                            <div style={{ flexGrow: 1 }}>
                                <input
                                    type="text"
                                    placeholder="Search Screens..."
                                    className="sk-input-dd mb-0"
                                    style={{ width: "100%" }}
                                    value={filterValues?.search}
                                    onChange={(e) => setFilterValues((prev) => ({ ...prev, search: e.target.value }))}
                                />
                            </div>
                            <button
                                type="button"
                                className="sk-btn text-white bg-black sk-btn-primary"
                                style={{ whiteSpace: "nowrap" }}
                                onClick={() => { setVisible({ show: true });}}
                            >
                                <FontAwesomeIcon icon="fa-solid fa-plus" /> Add Screen
                            </button>
                        </div>
                        <div className="mt-2 w100" style={{ height: "calc(100vh - 160px)", overflow: "auto" }}>
                            <CommonGrid columns={columns} data={[{ id: "all", title: "", children: rowData }]} expandAll={true} headerHeight={50} strippedTable={true} loader={loader?.grid} />
                        </div>
                    </>
            }

            <Dialog
                draggable={false}
                header="Create Screen"
                visible={visible?.show}
                onHide={() => { setVisible({ show: false }); setFieldValues({}) }}
                className='modal-xsmall'>
                <div>
                    <div className='row'>
                        {
                            formJson?.map((item, index) => (
                                renderField(item, index, (e) => { handleChange(item, e) }, fieldValues, {}, {
                                    is_edit: item?.textField, fromProject:
                                        fieldValues?.project_id !== 0
                                }, () => { }, () => { })
                            ))
                        }
                    </div>
                    <div className='d-flex gap-2 align-items-center justify-content-end'>
                        <button className='sk-btn sk-btn-primary' onClick={() => { setVisible({ show: false }); setFieldValues({}) }}>Cancel</button>
                        {
                            loader?.btn ? <button className="sk-btn text-white bg-black sk-btn-primary" style={{ width: "65px", height: "30px" }}>
                                <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                    <span className="sr-only"></span>
                                </div>
                            </button> : <button className='sk-btn text-white bg-black sk-btn-primary' onClick={() => upsertScreen()} >Submit</button>
                        }
                    </div>
                </div>
            </Dialog>
            <CommanDialog
                visible={visible?.delete}
                message={"Are You Sure You Want to delete it?"}
                handleClose={() => { setVisible((prev) => ({ ...prev, delete: false })) }}
                handleFun={() => {
                    upsertScreen(true)
                }}
                loader={loader?.btn}
            />
        </div>
    );
};

export default CreateScreens;